import JsonApi from "../../../api/jsonApi";
import {getLocalStorageItem} from "../../../misc/storageFunctions";
import store from "../../../store";
import {setContractsList, setContractsValues} from "../../../actions/contractsActions";
import {IS_AS_WORK_ORDER} from "../../../config";
import {shouldUseHomeDepotReceipt} from "../../priceWorksheet/discountFunctions";
// import {getPriceWithCurrency} from "../../../misc/helpers";
// import {
//   getBalanceDueAmount,
// } from "../../priceWorksheet/discountFinanceFunctions";

/**
 *
 * @returns {array}
 * */
export const getContracts = async () => {
  const {contractSigningState, fabricatorState} = store.getState();
  if (contractSigningState.contractsReceived || !fabricatorState.settings.useContractSigning || IS_AS_WORK_ORDER) {
    // NO CONTRACTS IN THE WORK ORDER ID MODE! THE CONTRACTS IS ON THEIR END
    if (!contractSigningState.contractsReceived) {
      store.dispatch(setContractsList([])); // set received property true
    }
    return []
  }
  try {
    const response = await JsonApi.getContractDocuments();
    console.log("response", response);
    if (response && Array.isArray(response.data)) {
      const savedContracts = getLocalStorageItem("activeContracts");
      let newOrderedList = response.data
        .sort((a, b) => (a.order > b.order) ? 1 : -1)
        .map((contract, contractIndex) => {
          contract.selected = false; // this is used in the checkbox
          contract.order = contractIndex;
          if (document.kvConfig.isBackend) {
            const fabId = document.kvConfig.userId || "noFabUser";
            if (savedContracts && savedContracts[fabId] && Array.isArray(savedContracts[fabId])
              && savedContracts[fabId].length > 0 && savedContracts[fabId].includes(contract.id)
              && !(fabricatorState.isAmericanStandard && IS_AS_WORK_ORDER && contractIndex === 0)) {
              contract.selected = true;
            }
          } else if (contract.isDefault) { // default is for customer, if it is unchecked - then do not use contract at all
            contract.selected = true;
          }
          if (response.data.length === 1 || (fabricatorState.isAmericanStandard && !IS_AS_WORK_ORDER && contractIndex === 0)) {
            // We need to always have the spec sheet loading for American standard as the first doc without selecting it
            // If there is only one contract - it should be selected by the default
            contract.selected = true;
          }
          return contract;
        });
      store.dispatch(setContractsList(newOrderedList))
      return newOrderedList
    } else {
      store.dispatch(setContractsList([])); // set received property true
      return []
    }
  } catch (error) {
    console.log("error", error);
    store.dispatch(setContractsList([])); // set received property true
    return []
  }
};

export const getSelectedContracts = (contractsList) => {
  if (!Array.isArray(contractsList) || !contractsList.length) {
    return []
  }
  return contractsList.filter(contract => contract.selected)
}

/**
 * When the Home Depot receipt is active (see shouldUseHomeDepotReceipt), the /sign url is needed to sign
 * the receipt inputs regardless of whether any contract is selected - callers that gate on selected
 * contracts (e.g. signIsDisabled in assignQuotePopupSaveButtons.js) should also check this.
 * @return {boolean}
 */
export const shouldForceContractSigningForHomeDepotReceipt = () => {
  const {fabricatorState, priceWorksheetState, wizardState, quotesState} = store.getState();
  return shouldUseHomeDepotReceipt(fabricatorState, priceWorksheetState.discountSections, wizardState.allWizardsValues,
    quotesState.quotes);
}

export const shouldUseContractSigning = (fabricatorSettings, allContractsList, withoutContractsCheck = false) => {
  if (!fabricatorSettings.useContractSigning) {
    return false;
  }
  if (withoutContractsCheck) {
    return true
  }
  if (IS_AS_WORK_ORDER) {
    return true
  }
  if (shouldForceContractSigningForHomeDepotReceipt()) { // yes, we need to go to the /sign url to sign the inputs
    return true
  }
  if (!allContractsList) {
    const {contractsList} = store.getState().contractSigningState;
    allContractsList = contractsList;
  }
  return getSelectedContracts(allContractsList).length
}

export const setContractBlobs = async (contractsList, receiptPagesLength = 0, isOfflineFirstLoad = false) => {
  let pagesCount = receiptPagesLength || 1; // start from 1 if receipt is broken
  let updatedContractsList = contractsList;
  for (const contract of updatedContractsList) {
    contract.pagesFrom = 0;
    contract.pagesTo = 0;
    if (contract.selected || isOfflineFirstLoad) {
      const useDocument = contract.documentWithoutTagsUrl || contract.documentUrl; // use without tags! but if not at least something
      if (useDocument && !contract.blobUrl) {
        const responseFetch = await fetch(useDocument);
        const blob = await responseFetch.blob();
        contract.blobUrl = URL.createObjectURL(blob);
      }
      contract.pagesFrom = pagesCount + (receiptPagesLength ? 1 : 0);
      pagesCount = pagesCount + contract.pagesCount;
      contract.pagesTo = pagesCount + (receiptPagesLength ? 1 : 0);
    }
  }
  if (isOfflineFirstLoad) {
    store.dispatch(setContractsList(updatedContractsList))
  }
  // console.log("contractsList", contractsList);
  return {updatedContractsList, totalPages: pagesCount}
}

export const getActiveContract = (contractsList, globalContractPage) => {
  return contractsList.find(contract => {
    return globalContractPage >=contract.pagesFrom && globalContractPage < contract.pagesTo
  })
}

export const getAllContractsValues = (contractsList, context) => {
  const selectedContracts = getSelectedContracts(contractsList);
  const activeContract = getActiveContract(selectedContracts, context.globalContractPage);
  const activeContractPage = activeContract
    ? context.globalContractPage + 1 - activeContract.pagesFrom
    : 1;
  return {
    ...context,
    selectedContracts,
    activeContract,
    activeContractPage
  }
}

export const changeContractsPage = (newPage, contractsList, context, changeContext) => {
  const {receiptPages, activeContract, globalContractPage} = context;
  const allValues = getAllContractsValues(contractsList, {...context, globalContractPage: newPage});
  // here we set false to show loader while the blob is reloading
  const showPage = (allValues.activeContract && activeContract && (allValues.activeContract.blobUrl === activeContract.blobUrl))
    || (receiptPages && (newPage <= receiptPages) && (globalContractPage <= receiptPages));

  changeContext({...context, globalContractPage: newPage, showPage});
}

export const setInitialContractValues = (contractList) => {
  return (dispatch, getState) => {
    if (!Array.isArray(contractList) || !contractList.length) {
      return
    }
    const storeState = getState();
    const {financePaymentType, financeActiveDiscount} = storeState.priceWorksheetState;

    contractList.forEach((contract) => {
      if (!contract.selected) {
        return
      }
      contract.fields?.forEach(field => {
        field.coords?.forEach((coord) => {
          switch (field?.name) {
            // case "balanceDue": {
            //   dispatch(setContractsValues({
            //     contractId: contract.id,
            //     pageIndex: coord.page,
            //     fieldIndex: coord.fieldIndexOnPage,
            //     name: field.name,
            //     value: getPriceWithCurrency(storeState.fabricatorState.settings, getBalanceDueAmount(storeState)),
            //   }));
            //   break;
            // }
            case "checkAch":
            case "creditCard": {
              dispatch(setContractsValues({
                contractId: contract.id,
                pageIndex: coord.page,
                fieldIndex: coord.fieldIndexOnPage,
                name: field.name,
                value: financePaymentType === field.name,
              }));
              break;
            }
            case "finance": {
              dispatch(setContractsValues({
                contractId: contract.id,
                pageIndex: coord.page,
                fieldIndex: coord.fieldIndexOnPage,
                name: field.name,
                value: !!financeActiveDiscount, // checked if finance discount is active
              }));
              break;
            }
            default:
              return null
          }
        });
      });
    });
  }
}
